module.exports = __webpack_public_path__ + "static/media/map.66d6370e.svg";